
const ServiceFollowUpModel = function (){
    const name = 'service_follow_up';
    return {
        name,
        state:{
            condition:{
                reservationCode:'',
                status:'',
            },
            newModal:{
                reservationId:'',
                reservationCode:'',
                followId:'',
                record:'',
                assignId:'',
                status:'',
            },
            list:[],
            page:{
                pageSize:30,
                current:1,
                total:0,
            },
            personList:[]
        },
        selectors:(state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition:()=>currentState.condition,
                getNewModalData:()=>currentState.newModal,
                getList:()=>currentState.list,
                getPage:()=>currentState.page,
                getPersonList:()=>currentState.personList,
            };
            return selectors;
        },
        api:{},
        actions:{
            changeCondition:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_SERVICE_FOLLOW_UP_CONDITION',
                    key,
                    value
                })
            },
            changeNewModalData:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_SERVICE_FOLLOW_UP_MODAL',
                    key,
                    value
                })
            },
            changeList:(list) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_SERVICE_FOLLOW_UP_LIST',
                    list
                })
            },
            changePage:(page) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_SERVICE_FOLLOW_UP_PAGE',
                    page
                })
            },
            changePersonList:(list) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_SERVICE_FOLLOW_UP_PERSON_LIST',
                    list
                })
            }
        },
        reducers:{
            condition:(state = ServiceFollowUpModel.state.condition, action) => {
                if(action.type === 'CHANGE_SERVICE_FOLLOW_UP_CONDITION'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            newModal:(state = ServiceFollowUpModel.state.newModal, action) => {
                if(action.type === 'CHANGE_SERVICE_FOLLOW_UP_MODAL'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            page:(state = ServiceFollowUpModel.state.page, action) => {
                if(action.type === 'CHANGE_SERVICE_FOLLOW_UP_PAGE'){
                    return Object.assign({}, state, action.page );
                }
                return state;
            },
            list:(state = ServiceFollowUpModel.state.list , action ) => {
                if(action.type === 'CHANGE_SERVICE_FOLLOW_UP_LIST'){
                    return [ ...action.list ];
                };
                return state;
            },
            personList:(state = ServiceFollowUpModel.state.personList , action ) => {
                if(action.type === 'CHANGE_SERVICE_FOLLOW_UP_PERSON_LIST'){
                    return [ ...action.list ];
                };
                return state;
            }
        }
    }
}();

export default ServiceFollowUpModel;


// WEBPACK FOOTER //
// ./src/models/ServiceFollowUpModel.js